import { useSaleLocation } from "app/hooks/shared/analytics/useSaleLocation";
import { createContext, useContext, useEffect } from "react";
import { CheckSaleLocationResponse } from "shared/api/middleware-api-client";
import { REACT_APP_GTM_TAG } from "shared/config";
import TagManager from "react-gtm-module";

interface AnalyticsContextProps {
  saleLocationResponse: CheckSaleLocationResponse | undefined;
  refetchSaleLocation: () => Promise<any>;
}

const AnalyticsContext = createContext({} as AnalyticsContextProps);
export const useAnalyticsContext = () => useContext(AnalyticsContext);

interface AnalyticsProviderProps extends React.PropsWithChildren {}
const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  const { data: saleLocationResponse, refetch: refetchSaleLocation } =
    useSaleLocation();

  useEffect(() => {
    if (!!window.dataLayer) return;
    const initializeTagManager = () => {
      if (!REACT_APP_GTM_TAG) {
        console.error("NO GTM TAG SPECIFIED");
      }

      const tagManagerArgs = {
        gtmId: REACT_APP_GTM_TAG,
        dataLayer: window.dataLayer,
      };
      TagManager.initialize(tagManagerArgs);
    };
    initializeTagManager();
  }, []);

  return (
    <AnalyticsContext.Provider
      value={{
        saleLocationResponse,
        refetchSaleLocation,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};
export default AnalyticsProvider;
